import React, {useEffect, useMemo, useState} from 'react';
import { ProfileEventTypes, ProfileUpComm } from './ProfileData';
import { getCountries } from '../../../api';
import { Option } from '../../magma-wrap/shared';
import { AsyncSelect } from '../../magma-wrap/AsyncSelect';
import { FacultyDataKeys } from './FacultyDataKeys';

export const TEST_ID = {
  MAIN: 'country-select',
  COUNTRY_SELECT_LOADING: 'loading-country'
};
const LABEL = 'Country';

export interface CountrySelectProps extends ProfileUpComm {
  value?: string;
  required?: boolean;
  name?: string;
  disabled?: boolean;
  onFocus?: () => void;
  onChange?: (option: Option) => void;
  errorMessage?: string | null;
  __testValues?: Option[];
}

export const CountrySelect: React.FunctionComponent<CountrySelectProps> = (
  props: CountrySelectProps
) => {
  const { __testValues, upComm, required, value, onFocus, onChange, errorMessage, disabled } = props;

  const initLoader = useMemo(() => {
    return (async () => {
      return __testValues ?? await getCountries() ?? [];
    })();
  }, [__testValues]);
  const initValue = useMemo(() => {
    return Promise.resolve(initLoader).then(v => v.find(w => w.item === value));
  }, [initLoader, value]);

  useEffect(() => {
    // This effect is meant to send a message telling the target
    // UpComm that this field is required.
    upComm?.sendMsg({
      type: ProfileEventTypes.dataRequired,
      data: {
        key: FacultyDataKeys.entityCountry,
        value: required && !disabled,
        label: LABEL
      }
    });
  }, [required, upComm, disabled]);

  return (
    <div className={required ? 'required-input' : ''} style={{ marginBottom: 15 }}>
      <AsyncSelect
        labelText={LABEL}
        id="country-select"
        helperMessage="Enter part of the country."
        filterOptions={(val, option) => {
          return option.label.toLowerCase().includes(val.toLowerCase());
        }}
        onInputFocus={onFocus}
        onSelectedItemChange={changes => {
          if (changes.selectedItem) {
            const { item, label, region } = changes.selectedItem;

            upComm &&
              upComm.sendMsg({
                type: ProfileEventTypes.dataChanged,
                data: {
                  key: FacultyDataKeys.entityCountry,
                  value: item
                }
              });

            upComm &&
            upComm.sendMsg({
              type: ProfileEventTypes.dataChanged,
              data: {
                key: FacultyDataKeys.entityRegion,
                value: region
              }
            });
            

            onChange?.({ item, label, region } as Option);
          }
        }}
        initItems={initLoader}
        initValue={initValue}
        disabled={disabled}
        testId={TEST_ID.MAIN}
        errorMessage={errorMessage}
      />
    </div>
  );
};
